export default __webpack_public_path__ + "static/media/Punto_10_Chiesa_degli_Olandesi_FRA_Def.07ec5927.aac";